import Image from 'next/image'
import Link from 'next/link'

export function Logo({ href, className }: { href?: string; className?: string }): JSX.Element {
  return (
    <Link href={href ?? '/'} className="flex flex-shrink-0 items-center">
      <Image
        width={0}
        height={0}
        priority
        className={className ?? 'inline-block h-10 w-auto dark:hidden'}
        src="/play/logo.svg"
        alt="Criteria"
      />
      <Image
        width={0}
        height={0}
        priority
        className={className ?? 'hidden h-10 w-auto dark:inline-block'}
        src="/play/logo-dark.svg"
        alt="Criteria"
      />
      <span className="font-regular text-xl tracking-tighter text-gray-700 dark:text-zinc-300">Playground</span>
    </Link>
  )
}
